export const ADVANTAGES_HEADING = 'CyberVision Advantages';
